import {HeroSection} from '@/shared/components/dashboard/landing-pages/form/HeroSection';
import {Menus} from '@/shared/components/dashboard/landing-pages/form/MenusSection';
import {Impression} from '@/shared/components/dashboard/landing-pages/form/ImpressionSection';
import {Introduction} from '@/shared/components/dashboard/landing-pages/form/IntroductionSection';
import {RoutePlan} from '@/shared/components/dashboard/landing-pages/form/RoutePlanSection';
import {Location} from '@/shared/components/dashboard/landing-pages/form/LocationSection';
import {Accommodation} from '@/shared/components/dashboard/landing-pages/form/AccommodationSection';
import {Activities} from '@/shared/components/dashboard/landing-pages/form/ActivitiesSection';
import {Videos} from '@/shared/components/dashboard/landing-pages/form/Videos';
import {Security} from '@/shared/components/dashboard/landing-pages/form/SecuritySection';
import {StaticSecuritySection} from '../components/dashboard/landing-pages/form/SecuritySection/Static';

export const COLUMNS_HEADERS = [{id: 'label', key: 'label', label: 'Label'}];

export const RECORDS_PER_PAGE = 20;

export const LANDING_PAGE_ACCORDION_ITEMS = {
  heroSection: {
    value: 'heroSection',
    label: '1. Hero Section',
    Component: HeroSection,
  },
  menusSection: {
    value: 'menusSection',
    label: '2. Call To Action Button (Menus)',
    Component: Menus,
  },
  introductionSection: {
    value: 'introductionSection',
    label: '3. Introduction Section',
    Component: Introduction,
  },
  impressionSection: {
    value: 'impressionSection',
    label: '4. Impression Section',
    Component: Impression,
  },
  routePlanSection: {
    value: 'routePlanSection',
    label: '5. Route Plan Section',
    Component: RoutePlan,
  },
  locationSection: {
    value: 'locationSection',
    label: '6. Location Section',
    Component: Location,
  },
  accommodationSection: {
    value: 'accommodationSection',
    label: '7. Accommodation Section',
    Component: Accommodation,
  },
  activitiesSection: {
    value: 'activitiesSection',
    label: '8. Activities Section',
    Component: Activities,
  },
  videosSection: {
    value: 'videosSection',
    label: '9. Videos Section',
    Component: Videos,
  },
  securitySection: {
    value: 'securitySection',
    label: '10. Security Section',
    Component: StaticSecuritySection,
  },
};

export const SECURITY_SECTION_ITEMS = {
  label: {en: 'Security', nl: 'Zekerheid'},
  includings: {
    title: {en: 'Included as standard', nl: 'Standaard inbegrepen'},
    description: {
      en: "With us, you don't just book a route, you book a complete experience. Everything you need for a carefree and well-prepared trip is included as standard.",
      nl: 'Bij ons boek je niet alleen een route, maar een complete ervaring. Alles wat je nodig hebt voor een zorgeloze en goed voorbereide reis is standaard inbegrepen.',
    },
    list: [
      {
        image: '/images/landing-page/roadtrip2go.svg',
        title: {
          en: 'Complete Roadtrip',
          nl: 'Complete Roadtrip',
        },
        description: {
          en: `The road trip is already completely planned for you. The itinerary, hotels, and at least one activity are included. You don't have to worry about anything else.`,
          nl: `De roadtrip is al helemaal voor je samengesteld. De planning, de hotels én minstens één activiteit zijn inbegrepen. Jij hoeft niets meer uit te zoeken.`,
        },
      },
      {
        image: '/images/landing-page/vzr.svg',
        title: {
          en: 'VZR guarantees protection',
          nl: 'VZR garant bescherming',
        },
        description: {
          en: `Your booking is fully financially protected by VZR Garant. This means your money is safe, even in the unlikely event something goes wrong with the tour operator.`,
          nl: `Je boeking is volledig financieel beschermd door VZR Garant. Dit betekent dat je geld veilig is, zelfs in het onwaarschijnlijke geval dat er iets misgaat met de reisorganisatie.`,
        },
      },
      {
        image: '/images/landing-page/whatsapp.svg',
        title: {
          en: 'Available 24/7',
          nl: '24/7 bereikbaar',
        },
        description: {
          en: `Wherever you are on your trip, we're always just a message away. Our team is available 24/7 to answer any questions.`,
          nl: `Waar je je ook bevindt tijdens je reis, wij zijn altijd maar één bericht van je verwijderd. Ons team is 24/7 bereikbaar om vragen te beantwoorden.`,
        },
      },
    ],
  },
  extras: {
    title: {en: 'Extra', nl: 'Extra'},
    description: {
      en: 'These extras are available at no extra cost to make your trip more enjoyable and relaxing.',
      nl: 'Deze extra’s zijn er zonder meerprijs om je reis plezieriger en ontspannen te maken.',
    },
    list: [
      {
        image: '/images/landing-page/roadtrip2go-checked.svg',
        title: {
          en: 'Roadtrip2go satisfaction guarantee',
          nl: 'Roadtrip2go tevredenheids garantie',
        },
        description: {
          en: `We strive for happy customers and valuable feedback to help us improve – nothing less. Not satisfied with our service? We'll refund our service fees!`,
          nl: `Wij gaan voor blije klanten of waardevolle feedback om ons te verbeteren – niets minder. Ben je niet tevreden over onze service? Dan krijg je onze servicekosten terug!`,
        },
      },
      {
        image: '/images/landing-page/book.svg',
        title: {
          en: 'Road trip guide Mobile',
          nl: 'Roadtrip gids Mobiel',
        },
        description: {
          en: `The Road Trip Guide is optimized for mobile and even works offline, so you always have information at your fingertips while on the road. From hotel check-in times to country-specific traffic regulations.`,
          nl: `De Roadtrip Gids is geoptimaliseerd voor mobiel en werkt zelfs offline — zo heb je onderweg altijd informatie binnen handbereik. Van hotel check-in tijden tot verkeersregels per land.`,
        },
      },
      {
        image: '/images/landing-page/spotify.svg',
        title: {
          en: 'Spotify Experience Playlist',
          nl: 'Spotify Experience Playlist',
        },
        description: {
          en: `Your road trip soundtrack, a curated playlist that sets the perfect mood from start to finish.`,
          nl: `Jouw roadtrip-soundtrack, een samengestelde playlist die de perfecte sfeer neerzet van begin tot eind.`,
        },
      },
    ],
  },
};
